






































































import {Component, Vue} from 'vue-property-decorator';
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import FillableDocumentDataDTO from "@/dto/archive/FillableDocumentDataDTO";
import FillableDocumentFilter from "@/dto/archive/FillableDocumentFilter";
import Workspaces from "@/state/Workspaces";
import {FillableDocumentType} from "@/dto/archive/FillableDocumentType";
import DocumentService from "@/services/DocumentService";
import Application from "@/state/Application";
import {processError} from "@/utils/ComponentUtils";
import {prettyEnum} from "@/utils/StringUtils";
import RouteNames from "@/router/RouteNames";
import CompanySearch from "@/components/common/CompanySearch.vue";
import ST120CreationModal from "@/components/archive/st120/ST120CreationModal.vue";
import {FillableDocumentStatus} from "@/dto/archive/FillableDocumentStatus";

@Component({
	methods: {prettyEnum},
	components: {CompanySearch, PaginationComponent}
})
export default class ST_120List extends Vue {

	private forms: Array<FillableDocumentDataDTO> = [];
	private totalPages = 1;
	private filter = new FillableDocumentFilter();

	mounted(): void {
		this.loadForms()
	}


	loadForms(): Promise<void> {
		Application.startLoading();
		this.filter.companyId = Workspaces.getCurrent.id;
		this.filter.documentType = FillableDocumentType.ST_120;
		return DocumentService.getST120Forms(this.filter).then(
			success => {
				this.forms = success.data.data;
				this.totalPages = success.data.countOfPages;
			},
			error => processError(error, this)
		).then(Application.stopLoading);
	}

	openNewDocument(): void {
		this.$modal.show(
			ST120CreationModal,
			{
				callBack: (documentId: number) => {
					this.$router.push(
						{
							name: RouteNames.ARCHIVE_ST120_INTERNAL,
							params: {
								documentId: documentId.toString()
							}
						}
					)
				}
			}
		)
	}

	private onFormClick(form: FillableDocumentDataDTO): void {
		if (form.status == FillableDocumentStatus.BEING_FILLED_OUT || form.status == FillableDocumentStatus.NEW) {
			this.$router.push(
				{
					name: RouteNames.ARCHIVE_ST120_INTERNAL,
					params: {
						documentId: form.id.toString()
					}
				}
			)
		} else if (form.status == FillableDocumentStatus.PENDING_SIGNATURE && form.companyId == this.$wss.getCurrent.id && form.signPublicKey) {
			this.$router.push({name: RouteNames.SIGN_PUBLIC, params: { publicId: form.signPublicKey }})
		} else if (form.signedFile){
			this.$docUtils.download(form.signedFile.id)
		}

	}

	private changePage(page: number) {
		this.filter.pageNumber = page;
		this.loadForms();
	}
}
